import styled, { css } from "styled-components";

import { COLOR, TEXT_COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { setFontStyle } from "@sellernote/ui/src/sds-v2/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

import { fadeUpAnimation } from "../../../components/landing/index.styles";

const container = styled.div`
  background-color: ${COLOR.grayScale_900};
  display: flex;
  justify-content: center;
  align-items: center;

  ${fadeUpAnimation}

  ${mobile(css`
    padding: 48px 24px 41px;
  `)}
`;

const content = styled.div`
  width: 1128px;
  height: 340px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mobile(css`
    width: 100%;
    height: initial;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 20px;
  `)}

  .coupon-image {
    animation-delay: 0.9s;

    ${mobile(css`
      order: 1;
      animation-delay: 0.3s;
    `)}
  }
`;

const titleAndDesc = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${mobile(css`
    order: 2;
    gap: 8px;
  `)}
`;

const title = styled.h3`
  color: ${TEXT_COLOR.white_1};
  ${setFontStyle("Head3")}
  animation-delay: 0.3s;

  ${mobile(css`
    ${setFontStyle("Head6")};
    animation-delay: 0.6s;
  `)}
`;

const desc = styled.p`
  color: ${TEXT_COLOR.white_1};
  ${setFontStyle("Body1")}
  animation-delay: 0.6s;

  ${mobile(css`
    ${setFontStyle("Body3")};
    animation-delay: 0.9s;
  `)}
`;

export default {
  container,
  content,
  titleAndDesc,
  title,
  desc,
};
